/* Svensk katalog for locale-vat-purchases-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'vat.term': 'Momsperiod',
  'vat.termHelp': 'En momsperiod är en period som du redovisar moms för. De flesta redovisar varannan månad - 6 perioder om året. För varje period summeras utgående och ingående moms, och skillnaden betalas till eller återbetalas från staten.',
  'vat.termShort': 'period',
  'vat.deadline': 'FRIST',
  'vat.amountHelp': 'Moms att betala betyder att du är skyldig staten eftersom utgående moms var större än ingående moms. Moms att återfå betyder att du får pengar tillbaka eftersom du har betalat mer moms på inköp än du tog ut på försäljning.',
  'vat.openReturn': 'Öppna deklaration',
  'vat.sortHelp': 'Perioderna är sorterade efter status: Kräver åtgärd måste lämnas in nu, Kommande är framtida perioder och Tidigare är redan inlämnade eller betalda.',
  'vat.noTerms': 'Inga momsperioder ännu',
  'vat.incompleteBasisTitle': 'Momsunderlaget är ofullständigt',
  'vat.incompleteBasisText': 'MVA-meldingen visas inte som komplett eftersom journaltäckningen inte är dokumenterad. Dokumentberäkningar kan fortfarande användas diagnostiskt, men inte som komplett redovisningsunderlag.',
  'vat.needsAction': 'Kräver åtgärd',
  'vat.upcoming': 'Kommande',
  'vat.earlier': 'Tidigare',
  'vat.toPay': 'Moms att betala',
  'vat.toPayHelp': 'Sammanlagd utestående moms där utgående moms är större än ingående moms.',
  'vat.paidIn': 'Inbetalt',
  'vat.paidInHelp': 'Momsbetalningar som du har registrerat mot perioder i Plumme.',
  'vat.refunded': 'Återbetalt',
  'vat.refundedHelp': 'Momsåterbetalningar som du har registrerat mot perioder i Plumme.',
  'vat.perTerm': 'Per period',
  'vat.returnStatus': 'Status för MVA-melding',
  'vat.period': 'Period',
  'vat.due': 'Frist',
  'vat.calculated': 'Beräknad avräkning',
  'vat.settlement': 'Avräkning',
  'vat.cancelPayment': 'Makulera betalning',
  'vat.date': 'Datum',
  'vat.amount': 'Belopp',
  'vat.reference': 'Referens',
  'vat.referencePh': 'T.ex. internetbank, OCR',
  'vat.payments': 'Betalningar',
  'vat.paymentsHelp': 'Översikt över betalningar registrerade mot denna momsperiod.',
  'vat.noPayments': 'Inga betalningar registrerade',
  'vat.fromAccount': 'Från konto',
  'vat.edit': 'Redigera',
  'vat.cancel': 'Makulera',
  'vat.cancelPaymentTitle': 'Makulera betalning?',
  'vat.cancelPaymentConfirm': 'Ja, makulera betalning',
  'vat.backToTerms': 'Tillbaka till perioder',
  'vat.importedBasisTitle': 'Importerat från annat redovisningssystem',
  'vat.importedBasisHelp': 'Siffrorna har importerats som underlag. Du kan skapa, skicka in och vid behov makulera MVA-meldingen med det vanliga flödet.',
  'vat.outputVat': 'Utgående moms',
  'vat.outputVatHelp': 'Moms som du har tagit ut på försäljningen under perioden.',
  'vat.inputVat': 'Ingående moms',
  'vat.inputVatHelp': 'Avdragsgill moms som du har betalat på inköp under perioden.',
  'vat.netVat': 'Nettomoms',
  'vat.netHelp': 'Utgående minus ingående moms. Positivt belopp betalas, negativt belopp återfås.',
  'vat.checkStatus': 'Kontrollera status',
  'vat.checkStatusHelp': 'Visa Plummes sparade status för MVA-meldingen. Automatisk status från Altinn eller Skatteetaten är inte kopplad i den här Plumme-vyn ännu.',
  'vat.seePayment': 'Visa betalning',
  'vat.seePaymentHelp': 'Se betalningarna som är registrerade mot denna momsperiod — datum, konto, belopp och referens.',
  'vat.codeOverview': 'Kodöversikt för inlämning',
  'vat.codeOverviewHelp': 'MVA-meldingen byggs upp av standardiserade momskoder från Skatteetaten. Varje kod samlar en viss typ av försäljning eller inköp. Underlaget är beloppet utan moms. Vid omvänd skattskyldighet visas både utgående och ingående moms, även när nettot är 0. Tryck på en kod för att se vad som hör hemma där.',
  'vat.codeTapHint': 'Tryck på en kod för att se vad som hör hemma där.',
  'vat.code': 'Kod',
  'vat.description': 'Beskrivning',
  'vat.basis': 'Underlag',
  'vat.rate': 'Sats',
  'vat.vat': 'Moms',
  'vat.calculatedFrom': 'Beräknat utifrån det du har registrerat i appen',
  'vat.delete': 'Ta bort',
  'vat.annulCustoms': 'Makulera',
  'vat.annulled': 'Makulerad',
  'vat.showAnnulledCustoms': 'Visa makulerade',
  'vat.showActiveCustoms': 'Visa aktiva',
  'vat.customsAnnulled': 'Tulldeklaration makulerad',
  'vat.customsAnnulFailed': 'Det gick inte att makulera tulldeklarationen.',
  'vat.registerCustoms': 'Registrera tulldeklaration',
  'vat.customsHelp': 'Lägg in en tulldeklaration för varor som du har importerat från utlandet. Plumme räknar ut importmoms från statistiskt värde och lägger in den på rätt kod i deklarationen.',
  'vat.flowHelp': 'Kontrollera siffrorna från de bokförda verifikationerna. Plumme kan inte skicka MVA-meldingen: du lämnar in den i Skatteetatens tjänst och markerar sedan perioden som inlämnad utanför Plumme här. Då kan du registrera betalningen. Inlämnad-status kan tas bort igen om den sattes av misstag.',
  'vat.filing.statusFiled': 'Inlämnad utanför Plumme',
  'vat.filing.statusFiledPaid': 'Inlämnad utanför Plumme och betald',
  'vat.filing.statusNotFiled': 'Inte markerad som inlämnad',
  'vat.filing.reviewFigures': 'Kontrollera siffrorna',
  'vat.filing.reviewedToast': 'Siffrorna är kontrollerade. Lämna in MVA-meldingen hos Skatteetaten.',
  'vat.filing.markOutside': 'Markera som inlämnad utanför Plumme',
  'vat.filing.clearStatus': 'Ta bort inlämnad-status',
  'vat.filing.dialogTitle': 'Lämna in MVA-meldingen hos Skatteetaten',
  'vat.filing.cannotSend': 'Plumme kan inte skicka eller signera MVA-meldingen. Du lämnar själv in den hos Skatteetaten och markerar perioden som inlämnad här efteråt.',
  'vat.filing.step1': 'Öppna MVA-meldingen i Skatteetatens tjänst och för in siffrorna för denna period från Plumme.',
  'vat.filing.step2': 'Skicka in och signera deklarationen där och spara kvittensen.',
  'vat.filing.step3': 'Markera perioden som inlämnad utanför Plumme här. Då kan du registrera betalningen, och perioden räknas som inlämnad i bokslutet.',
  'vat.filing.termNotEnded': 'Perioden är inte slut ännu. MVA-meldingen kan lämnas in först när perioden är slut.',
  'vat.filing.filedDate': 'Inlämningsdatum',
  'vat.filing.reference': 'Referens (valfritt)',
  'vat.filing.referencePh': 'Till exempel referensen på kvittensen från Skatteetaten',
  'vat.filing.comment': 'Kommentar (valfritt)',
  'vat.filing.lockNote': 'När perioden har markerats som inlämnad låses verifikationerna i perioden. Ändringar måste då göras som en rättelse.',
  'vat.filing.clearText': 'Perioden står då som inte inlämnad i Plumme, och verifikationerna i perioden låses upp igen. Ändringen loggas med vem och när. Status hos Skatteetaten ändras inte.',
  'vat.filing.clearReason': 'Motivering (valfritt)',
  'vat.filing.markedToast': 'Perioden har markerats som inlämnad utanför Plumme',
  'vat.filing.clearedToast': 'Inlämnad-status har tagits bort',
  'vat.filing.failed': 'Det gick inte att uppdatera momsstatus.',
  'vat.filing.payAfterFiled': 'Tillgängligt när MVA-meldingen har lämnats in hos Skatteetaten och markerats som inlämnad här.',
  'vat.filing.markedOn': 'Markerad i Plumme',
  'vat.filing.referenceLabel': 'Referens',
  'vat.filing.commentLabel': 'Kommentar',
  'vat.filing.statusNote': 'Plumme hämtar inte status från Skatteetaten. Statusen här är det som har markerats i Plumme.',
  'vat.addComment': 'Lägg till kommentar',
  'vat.customs': 'Tulldeklaration',
  'vat.correctCustoms': 'Rätta tulldeklaration',
  'vat.saveCustoms': 'Spara tulldeklaration',
  'vat.fetchFromAltinn': 'Hämta från Altinn',
  'vat.fetchFromAltinnHelp': 'Fyll i referens och tullunderlag automatiskt från inlämnade deklarationer.',
  'vat.declarationRef': 'Deklarationsreferens',
  'vat.declarationRefPh': 'Referens från tullen',
  'vat.statisticalValue': 'Statistiskt värde',
  'vat.vatCode': 'Momskod',
  'vat.attachments': 'Bilagor / importspår',
  'vat.uploadAttachment': 'Ladda upp bilaga',
  'vat.attachmentHelp': 'Valfritt, men rekommenderas för verifieringskedjan och senare importuppföljning.',
  'vat.customsBasis': 'Tullunderlag',
  'vat.calculatedVat': 'Beräknad moms',
  'vat.deductible': 'Avdragsrätt',
  'vat.settlementDate': 'Regleringsdatum',
  'vat.settlementType': 'Typ av reglering',
  'vat.useDueDate': 'Förfallodatum',
  'vat.useDueDateHelp': 'Sätt regleringsdatumet till förfallodatumet för MVA-meldingen',
  'vat.addSurcharges': 'Lägg till ränta/avgift',
  'vat.surcharges': 'Ränta och avgift',
  'vat.removeSurcharges': 'Ta bort',
  'vat.lateInterest': 'Dröjsmålsränta',
  'vat.lateInterestHelp': 'Bokförs som räntekostnad på 8150',
  'vat.penaltyFee': 'Avgift eller vite',
  'vat.penaltyFeeHelp': 'Bokförs på 7799 och är inte avdragsgill',
  'vat.surchargeTotal': 'Dras från kontot',
  'vat.surchargeNote': 'Ränta och avgifter är inte moms. De kostnadsförs och dras från kontot, men ändrar inte momsredovisningen för perioden.',
  'vat.kid': 'KID',
  'vat.payTitle': 'Betala moms till Skatteetaten',
  'vat.payHelp': 'Kontonummer och KID kommer från Skatteetaten när meldingen är behandlad. Betalning direkt från banken är inte ansluten än, så betalningen registreras i Plumme tills vidare.',
  'vat.awaitingAuthority': 'Kommer från Skatteetaten',
  'vat.pay': 'Betala',
  'vat.kidHelp': 'KID från MVA-meldingen',
  'vat.authorityAccount': 'Skatteetatens kontonummer',
  'vat.authorityAccountHelp': 'Skatteetatens kontonummer',
  'vat.notRegistered': 'Företaget är inte angivet som momsregistrerat',
  'vat.view': 'Vy',
  'vat.viewHelp': 'Växla mellan ”Perioder” — ett kort per momsperiod med status och frist — och ”Översikt”, som sammanfattar vad du är skyldig, har betalat och har att få tillbaka över alla perioder.',
  'vat.viewTerms': 'Perioder',
  'vat.viewOverview': 'Översikt',
  'vat.filing.notFiled': 'Inte inlämnad',
  'vat.filing.upcomingStatus': 'Kommande',
  'vat.filing.importedArchive': 'Importerat arkiv',
  'vat.vatReceivable': 'Moms att få tillbaka',
  'vat.vatToPay': 'Moms att betala',
  'vat.noVat': 'Ingen moms',
  'vat.receivableShort': 'Att få tillbaka',
  'vat.remainingToPay': 'Återstår att betala',
  'vat.termLabel': 'Period {n} {year}',
  'vat.noTermsHelp': 'När företaget är momsregistrerat visar Plumme perioder, frister och beräknad moms här.',
  'vat.youOwe': 'Du är skyldig',
  'vat.youAreOwed': 'Du har att få tillbaka',
  'vat.noVatToSettle': 'Ingen moms att reglera',
  'vat.refund': 'Återbetalning',
  'vat.paymentNoun': 'Betalning',
  'vat.settlementNoun': 'Reglering',
  'vat.acctBankDeposit': 'Bankinsättning',
  'vat.acctTaxDeductionAccount': 'Skatteavdragskonto',
  'vat.acctCash': 'Kontanter',
  'vat.accountFallback': '{code} Konto',
  'vat.settlementFullyRegistered': 'Helt registrerad',
  'vat.settlementPartiallyRegistered': 'Delvis registrerad',
  'vat.settlementNotRegistered': 'Inte registrerad',
  'vat.editRefund': 'Redigera återbetalning',
  'vat.editPayment': 'Redigera betalning',
  'vat.receivedOn': 'Mottagen på',
  'vat.paidFrom': 'Betald från',
  'vat.noPaymentsHelp': 'När du registrerar betalning eller återbetalning för perioden visas den här.',
  'vat.addRefund': 'Lägg till återbetalning',
  'vat.addPayment': 'Lägg till betalning',
  'vat.cancelPaymentConfirmPrefix': 'Vill du makulera {kind} på',
  'vat.cancelPaymentConfirmDate': ' registrerad {date}',
  'vat.cancelPaymentConfirmSuffix': '? Beloppet tas bort från momsperioden och kan inte återställas.',
  'vat.overpaid': 'Betalat för mycket',
  'vat.overrefunded': 'Fått tillbaka för mycket',
  'vat.remainingToReceive': 'Återstår att få tillbaka',
  'vat.registerSettlement': 'Registrera reglering',
  'vat.registerPayment': 'Registrera betalning',
  'vat.registerRefund': 'Registrera återbetalning',
  'vat.inYourFavor': 'till din fördel',
  'vat.toTaxAuthority': 'till Skatteetaten',
  'vat.receivedBack': 'Fått tillbaka',
  'vat.archiveCannotSettle': 'Importerad historik kan inte regleras som en ny Plumme-period.',
  'vat.noVatToSettleForTerm': 'Perioden har ingen moms att reglera.',
  'vat.sourceImported': 'Importerad',
  'vat.sourceManual': 'Registrerad manuellt',
  'vat.registerVatRefund': 'Registrera momsåterbetalning',
  'vat.registerVatPayment': 'Registrera momsbetalning',
  'vat.saveRefund': 'Spara återbetalning',
  'vat.savePayment': 'Spara betalning',
  'vat.remainingHint': 'Återstår {amount}',
  'vat.notRegisteredHelp': 'När företaget anges som momsregistrerat i inställningarna visar Plumme momsperioder, kodöversikt och reglering här.',
  'vat.reviewReadyToast': 'MVA-meldingen är förberedd för kontroll',
  'vat.customsAltinnNotConnected': 'Altinn-import för tulldeklarationer är inte ansluten än.',
  'vat.selectAttachmentToUpload': 'Välj en bilaga att ladda upp',
  'vat.customsDefaultDescription': 'Tulldeklaration',
  'vat.customsDateTermHint': 'Datumet måste ligga inom {period}.',
  'vat.customs81': '25 % med avdragsrätt',
  'vat.customs82': '25 % utan avdragsrätt',
  'vat.customs83': '15 % med avdragsrätt',
  'vat.customs84': '15 % utan avdragsrätt',
  'vat.customs85': '0 % import',
  'vat.customsSaved': 'Tulldeklarationen har sparats',
  'vat.customsSaveFailed': 'Kunde inte spara tulldeklarationen.',
  'vat.customsDeleted': 'Tulldeklarationen har tagits bort',
  'vat.customsDeleteFailed': 'Kunde inte ta bort tulldeklarationen.',
  'vat.refundSaved': 'Återbetalningen har sparats',
  'vat.paymentSaved': 'Betalningen har sparats',
  'vat.paymentSaveFailed': 'Kunde inte spara betalningen.',
  'vat.refundCancelled': 'Återbetalningen har makulerats',
  'vat.paymentCancelled': 'Betalningen har makulerats',
  'vat.paymentCancelFailed': 'Kunde inte makulera betalningen.',
  'vat.supplierSearch': 'Sök eller lägg till leverantör...',
  'vat.supplierClose': 'Stäng leverantörsval',
  'vat.supplierNone': 'Inga leverantörer hittades.',
  'vat.supplierNew': 'Ny leverantör',
  'vat.supplierName': 'Namn',
  'vat.supplierOrg': 'Org.nr',
  'vat.supplierEmail': 'E-post',
  'vat.supplierPhone': 'Telefon',
  'vat.customsPostingExplanation': 'Använd siffrorna från tulldeklarationen. Moms utan avdragsrätt måste bokföras på rätt kostnads- eller tillgångskonto.',
  'vat.nonDeductibleAccount': 'Konto för moms utan avdragsrätt',
  'vat.nonDeductibleAccountHelp': 'Välj samma kostnads- eller tillgångskonto som anskaffningen gäller. Konto måste anges före bokföring.',
  'voucherList.titleHelp': 'En verifikation är dokumentationen bakom en bokföring: faktura, kvitto, annan försäljning, tulldeklaration eller fri kontering. Här ser du verifikationerna som har hämtats från backend för valt räkenskapsår.',
  'voucherList.backToTrialBalance': 'Tillbaka till råbalansen',
  'voucherList.backToIncomeStatement': 'Tillbaka till resultaträkningen',
  'voucherList.accountBadge': 'Konto {number} · {name}',
  'voucherList.vatCodeBadge': 'Momskod {code}',
  'voucherList.viewOptions': 'Visningsval',
  'voucherList.noneForVatCode': 'Inga verifikationer hittades för momskod {code} i vald period.',
  'voucherList.noneForAccount': 'Inga verifikationer bokförda på {number} {name} under {year}.',
  'voucherList.noneMatchSearch': 'Inga verifikationer matchar sökningen.',
  'voucherList.noneInView': 'Inga verifikationer matchar vyn.',
  'voucherList.ledgerLinesMissing': 'Verifikationerna saknar bokföringsrader från backend.',
  'voucherList.debit': 'Debet',
  'voucherList.credit': 'Kredit',
  'voucherList.colVoucher': 'Verifikation',
  'voucherList.colNumber': 'Ver.nr',
  'voucherList.colDate': 'Datum',
  'voucherList.inlineVat': 'Moms',
  'voucherList.kindInvoice': 'Faktura',
  'voucherList.kindSupplier': 'Leverantör',
  'voucherList.kindCreditNote': 'Kreditfaktura',
  'voucherList.kindManual': 'Manuell verifikation',
  'voucherList.kindPurchase': 'Inköp',
  'voucherList.kindOtherSale': 'Annan försäljning',
  'voucherList.kindMileage': 'Körjournal',
  'voucherList.kindCustoms': 'Tulldeklaration',
  'voucherList.kindCustomsCorrection': 'Periodkorrigering av tulldeklaration',
  'voucherList.kindBankPosting': 'Bankkontering',
  'voucherList.kindPayment': 'Betalning',
  'voucherList.kindPayroll': 'Lön',
  'voucherList.kindPayrollPayment': 'Löneutbetalning',
  'voucherList.kindReversal': 'Återföring',
  'voucherList.kindPublicFees': 'Offentliga avgifter',
  'voucherList.kindAssetDisposal': 'Avyttring av inventarie',
  'voucherList.kindYearEnd': 'Bokslut',
  'voucherList.kindQuote': 'Offert',
  'voucherList.kindOrderConfirmation': 'Orderbekräftelse',
  'voucherList.filterSales': 'Försäljning',
  'voucherList.filterSupplierInvoice': 'Leverantörsfaktura',
  'voucherList.filterFreePosting': 'Fri kontering',
  'voucherList.missingAttachment': 'Saknar bilaga',
  'voucherList.hasAttachment': 'Har bilaga',
  'voucherList.unpaid': 'Obetald',
  'voucherList.showAnnulled': 'Visa makulerade',
  'voucherList.hidePayments': 'Dölj betalningar',
  'voucherList.includeAnnulled': 'Visa även makulerade',
  'vat.amountOnly': 'Enbart moms',
  'voucherList.onlyAnnulled': 'Visa bara makulerade',
  'voucherList.paid': 'Betald',
  'voucherList.partiallyPaid': 'Delbetald',
  'voucherList.annulled': 'Makulerad',
  'voucherList.attachmentLost': 'Verifikation borta',
  'voucherList.openInvoiceList': 'Visa i fakturalistan',
  'voucherList.editSale': 'Redigera försäljning',
  'voucherList.openInBank': 'Öppna i bank',
  'voucherList.editPosting': 'Redigera kontering',
  'voucherList.correctPosting': 'Korrigera verifikation',
  'voucherList.editMileage': 'Redigera körjournal',
  'voucherList.openInVat': 'Öppna i moms',
  'voucherList.edit': 'Redigera',
  'voucherList.purchaseNotFound': 'Hittade inte inköpet som ska redigeras. Prova att uppdatera sidan och öppna verifikationen igen.',
  'voucherList.saleNotFound': 'Hittade inte försäljningen som ska redigeras. Prova att uppdatera sidan och öppna verifikationen igen.',
  'inboxStatus.alreadyBooked': 'Redan bokförd?',
  'inboxStatus.booked': 'Bokförd',
  'inboxStatus.inTrash': 'I papperskorgen',
  'inboxStatus.readyToBook': 'Klar för bokföring',
  'inboxStatus.needsReview': 'Behöver kontroll',
  'inboxStatus.analysisFailed': 'Analysen misslyckades',
  'inboxStatus.analyzing': 'Analyseras',
  'inboxStatus.awaitingAnalysis': 'Väntar på analys',
  'inboxStatus.show': 'Visa',
  'inboxStatus.hide': 'Dölj',
  'inboxStatus.dropReceipts': 'Släpp verifikationerna här',
  'inboxStatus.dropReceiptsHint': 'SuperPlumma läser av det vi kan',
  'inboxStatus.dropDocuments': 'Släpp dokumenten här',
  'inboxStatus.dropDocumentsHint': 'Läggs i Dokumentation',
  'inboxStatus.bookWithSuperPlumma': 'Bokför med SuperPlumma',
  'inboxStatus.saving': 'Sparar...',
  'purchaseFlow.stepReceipt': 'Verifikation',
  'purchaseFlow.stepDetails': 'Detaljer',
  'purchaseFlow.stepLines': 'Rader',
  'purchaseFlow.stepPreview': 'Förhandsgranskning',
  'purchaseFlow.typeRegular': 'Betalt inköp',
  'purchaseFlow.typeInvoice': 'Leverantörsfaktura',
  'purchaseFlow.typeDrafts': 'Utkast',
  'purchaseFlow.receivedReading': 'Verifikation mottagen - SuperPlumma läser den nu',
  'purchaseFlow.receivedReadingMany': '{count} verifikationer mottagna - SuperPlumma läser dem nu',
  'purchaseFlow.prefilled': 'SuperPlumma fyllde i det som kunde läsas från verifikationen. Kontrollera innan du bokför.',
  'purchaseFlow.amountReview': 'Belopp och moms kunde inte fyllas i säkert. Kontrollera verifikationen och ange nettobelopp och rätt momshantering per rad innan du bokför.',
  'purchaseFlow.analysisFailed': 'Verifikationen laddades upp, men analysen misslyckades.',
  'purchaseFlow.inboxResolveFailed': 'Bokföringen är sparad, men verifikationen togs inte bort från inkorgen. Markera den som bokförd där.',
  'purchaseFlow.receiptFallbackName': 'Verifikation',
});
